import { useContext } from 'react';
import AuthContext from '../../store/auth-context';

const StudyStatusAlerts = (props) => {
	const authCtx = useContext(AuthContext);
	const userRole = authCtx.userData.role;

	console.log(props.issue);
	let alertMessage =
		'Our team is reviewing your submission. We will notify you once the results are ready.';
	let alertClass = 'alert alert-info';
	if (props.status === 'ONE' && userRole == 'QA') {
		alertMessage =
			'The Coverage Analysis is ready. Please review.';
	} else if (props.status === 'ONE' && userRole == 'PI') {
		alertMessage =
			'The QA is reviewing the Coverage Analysis. We will notify you once revision is completed.';
	} else if (props.status === 'TWO' && userRole == 'QA') {
		alertMessage =
			'The P.I is reviewing the Coverage Analysis. We will notify you once revision is completed.';
		alertClass = 'alert alert-success';
	} else if (props.status === 'TWO' && userRole == 'PI') {
		alertMessage =
			'The Coverage Analysis is ready. Please review.';
	} else if (props.status === 'REVISION_REQUESTED') {
		alertMessage =
			'We received your revision request. Our team is working on it. We will notify you once is completed.';
	} else if (props.status === 'STUDY_COMPLETED') {
		alertMessage = ' The Coverage Analysis is Completed.';
		alertClass = 'alert alert-secondary';
	} else if (props.status === 'SUBMITTED_FOR_ANALYSIS') {
		alertMessage =
			'Our team is reviewing your submission. We will notify you once the results are ready.';
		alertClass = 'alert alert-info';
	} else if (props.status === 'ARCHIVED') {
		alertMessage = ' The Coverage Analysis is Completed.';
		alertClass = 'alert alert-secondary';
	} else {
		alertMessage =
			'Our team is reviewing your submission. We will notify you once the results are ready.';
		alertClass = 'alert alert-info';
	}
	return (
		<>
			{props.issue == '' ? (
				<div className={alertClass} role='alert'>
					{alertMessage}
				</div>
			) : (
				<div className='alert alert-warning' role='alert'>
					We have detected a potential issue with the
					protocol uploaded to the platform. Our technical
					team is fully committed to resolving it promptly.
					Thank you for your understanding.
				</div>
			)}
		</>
	);
};
export default StudyStatusAlerts;
